<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:error="errorHandler"
      />
  
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
  
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import moment from "moment";

import WorkflowMaintenanceForm from "../../../components/settings/workflowmaintenance/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": WorkflowMaintenanceForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      isTran: this.$route.params.isTran || false,
      search: this.$route.params.search,
      pageTitle: this.$t('recworkflowmaintenance.editworkflowmaintenancelist'),
      pageTitleValue: "",
      formData: [],
      wftrandinfo: [],
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    async loadWorkflow() {
      const vm = this;

      try {
        const url = this.isTran
          ? `/workflowmaintenancenew/tran/${this.id}`
          : `/workflowmaintenancenew/${this.id}`;

        const res = await this.$store.dispatch('get', { url });

        if (res.data.rec[0].recdate) {
          res.data.rec[0].recdate = moment(res.data.rec[0].recdate).format("YYYY-MM-DD");
        }

        vm.formData = res.data.rec[0];
        await this.loadWorkflowDetail();
      }
      catch(err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
        vm.loading = false;
      }
    },

    async loadWorkflowDetail() {
      const vm = this;

      // isTran: load ALL approver records for this wftran
      // otherwise: load the specific wftrand record
      const url = this.isTran
        ? `/workflowmaintenancedetailinfo/${this.formData.wftranid}`
        : `/workflowmaintenancedetail/${this.formData.id}/${this.formData.wftranid}`;

      try {
        const res = await this.$store.dispatch('get', { url });

        vm.formData.wftrand = res.data.rec;

        for (let i = 0; i < res.data.rec.length; i++) {
          if (res.data.rec[i].wftranddate) {
            res.data.rec[i].wftranddate = moment(res.data.rec[i].wftranddate).format("YYYY-MM-DD HH:mm:ss");
          }
          if (res.data.rec[i].aprdate) {
            res.data.rec[i].aprdate = moment(res.data.rec[i].aprdate).format("YYYY-MM-DD HH:mm:ss");
          }
          // Per-user Date Format convention: DD-MM-YYYY (claims only carry receiptdate)
          if (res.data.rec[i].receiptdate) {
            res.data.rec[i].receiptdate = moment(res.data.rec[i].receiptdate).format("DD-MM-YYYY");
          }
        }

        vm.loading = false;
      } catch(err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
        vm.loading = false;
      }
    },

    //   loadWorkflowDetailInfo() {
    //   const vm = this;

    //   this.$store.dispatch('get', {
    //       url: `/workflowmaintenancedetailinfo/${this.formData.wftranid}`
    //     })
    //     .then((res) => {

    //       vm.formData.wftrandinfo = res.data.rec;

    //       console.log('wftrandinfo', vm.formData.wftrandinfo)

    //       for (let i = 0; i < res.data.rec.length; i++) {
    //         if (res.data.rec[i].wftranddate) {
    //           res.data.rec[i].wftranddate = moment(res.data.rec[i].wftranddate).format(
    //             "YYYY-MM-DD HH:mm:ss"
    //           );
    //         }

    //         if (res.data.rec[i].aprdate) {
    //           res.data.rec[i].aprdate = moment(res.data.rec[i].aprdate).format(
    //             "YYYY-MM-DD HH:mm:ss"
    //           );
    //         }
    //       }
    //       vm.loading = false;
    //       this.loadWorkflowDetail();
    //     })
    //     .catch((err) => {
    //       vm.isErr = !vm.isErr;
    //       vm.errMsg = err;
    //     });
    // },


    saveHandler() {
      const vm = this;
      //console.log('formdata', this.formData)
      //console.log('abc')
      this.$store.dispatch('put', {
        url: `/workflowmaintenance/${this.formData.id}`,
        payload: vm.formData
      })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workflowmaintenancelist" , params: { search: this.search}});
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    this.editMode = true;
    await this.loadWorkflow();
  },
};
</script>